// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"followAndPayment_buttonContainer__36jr-","tablesContainer":"followAndPayment_tablesContainer__3dmnj","fullWidth":"followAndPayment_fullWidth__J1AuY"};